import * as olSource from 'ol/source'

export default function ESRILightGray() {
  return new olSource.XYZ({
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attributions: [
      '<a  target="_blank" style="color: #2B6CB0;" href="https://huskroua-cbc.eu/">GEOSES</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.sgo-penc.hu/index_eng.php">SGO</a>, <a  target="_blank" style="color: #2B6CB0;" href="https://www.bme.hu/?language=en">BME</a>  Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ', 
     
    ]
  })
}
